import { API } from "@/lib/api";
import { Megaphone } from "lucide-react";

export function MarketingCarousel({ banners }) {
  if (!banners.length) return null;
  return (
    <section className="mx-auto max-w-7xl px-4 py-8" data-testid="marketing-carousel-container">
      <div className="mb-4 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.24em] text-blue-700">
        <Megaphone className="h-4 w-4" /> Current promotions
      </div>
      <div className="flex snap-x gap-5 overflow-x-auto pb-4">
        {banners.map((banner) => (
          <img
            key={banner.id}
            src={`${API}/public/banners/${banner.id}/image`}
            alt="BusinessBox promotional banner"
            className="h-56 min-w-[80%] snap-center rounded-3xl border border-gray-200 object-cover shadow-sm md:min-w-[48%]"
            loading="lazy"
          />
        ))}
      </div>
    </section>
  );
}
